module.exports = __webpack_public_path__ + "static/gm-37-f4e0762f1ca438f7aba5ba6bfab26fa7.jpg";